import styled from "styled-components";

export const CardWrap = styled.div`
  background-color: white;
  max-width: 306px;
  width: 300px;
  height: auto;
  max-height: 800px;
  box-shadow: 0px 4px 10px 0px #0000000a;
  border-radius: 8px;
  padding: 20px;
  position: relative;
  .card-header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 36px;
    padding: 10px 16px;
    font-weight: 500;
    font-size: 15px;
    color: #343c6a;
  }
  .three-dots {
    cursor: pointer;
    font-size: 20px;
  }
  .sector {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .title {
    font-size: 14px;
    font-weight: 500;
    color: #343c6a;
    font-family: Inter;
  }
  .desc {
    font-size: 15px;
    display: -webkit-box;
    font-weight: 600;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const Header = styled.div`
  display: flex;
  width: 100%;
  align-items: start;
  justify-content: space-between;
  h2 {
    font-family: Inter;
    font-size: 20px;
    font-weight: 600;
    line-height: 24.2px;
    color: #343c6a;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .name {
    font-family: Inter;
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
    color: #28303f;
  }
  .category {
    font-family: Inter;
    font-size: 20px;
    font-weight: 600;
    line-height: 24.2px;
    color: #6959de;
  }
  p {
    font-family: Inter;
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
    color: #8490a5;
  }
`;
export const ThreeDotsContainer = styled.div`
  position: absolute;
  right: 20px;
  top: 43px;
  z-index: 1;
  height: 50px;
  font-size: 13px;
  font-weight: 500;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  padding: 7px 10px;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 0px 0px 10px #cececf;
`;

export const UpdateIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #8490a5;
  font-size: 12px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  .editicon {
    color: #8490a5;
  }
  :hover {
    color: #6610f2;
    .editicon {
      color: #6610f2;
    }
  }
`;

export const DeleteIcon = styled.div`
  display: flex;
  align-items: center;
  color: #8490a5;
  gap: 6px;
  .delicon {
    color: #8490a5;
  }
  :hover {
    color: red;
    .delicon {
      color: red;
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
  .date-title {
    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 13px;
    color: #8490a5;
  }
  .date {
    font-family: Inter;
    font-size: 15px;
    font-weight: 600;
    line-height: 15px;
    color: #343c6a;
    padding-top: 10px;
  }
`;
